var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.724 9.473c.02.282.02.564.02.848 0 8.675-6.605 18.679-18.68 18.679v-.005A18.587 18.587 0 0 1 0 26.052a13.184 13.184 0 0 0 9.716-2.72 6.573 6.573 0 0 1-6.133-4.56c.984.19 1.998.151 2.964-.113a6.565 6.565 0 0 1-5.266-6.434v-.084c.912.509 1.934.79 2.98.822a6.573 6.573 0 0 1-2.033-8.765 18.634 18.634 0 0 0 13.53 6.858 6.573 6.573 0 0 1 11.188-5.987c1.471-.29 2.88-.83 4.17-1.594a6.589 6.589 0 0 1-2.886 3.63A13.057 13.057 0 0 0 32 6.072a13.336 13.336 0 0 1-3.276 3.4Z",
    fill: "currentColor"
  })));
};
export default SvgTwitter;